import { useVacancyControllerGetStatisticsQuery } from '@api/admin/adminGeneratedApi';

export const useGetVacancyStatisticById = (id: string) => {
  const { data, isLoading } = useVacancyControllerGetStatisticsQuery({
    id,
  });

  return {
    data,
    isLoading,
  };
};
